export default __webpack_public_path__ + "static/media/fpa40004.db0c86ba.png";